import { SupportedFileMimeTypes } from './types';
export const MAX_LOGO_UPLOAD_SIZE_BYTES = 100000; // 100kb
export const MAX_ATTACHMENT_UPLOAD_SIZE_BYTES = 10000000; // 10mb
export const MAX_FILE_UPLOAD_SIZE_BYTES = 2000000000; // 2gb
export const MAX_BULK_UPLOAD_FILES_AMOUNT = 1000;
export const UPLOAD_DOCUMENT_SUPPORTED_MIME_TYPES = [SupportedFileMimeTypes.PDF, SupportedFileMimeTypes.DOCX];
export const UPLOAD_LOGO_SUPPORTED_MIME_TYPES = [SupportedFileMimeTypes.PNG, SupportedFileMimeTypes.JPEG];
